import {
  sortDirection as _sortDirection,
  sortDirection,
} from "../utils/constants/genericTypes";
import { orderBy } from "lodash";

export const sortByDirection = (
  sortDirections: Array<sortDirection>,
  columnKeys: Array<string>,
  list: any
) => {
  const iteratees = columnKeys.map((key) => (item: any) => {
    const val = item[key];
    if (typeof val === "string") {
      const numStr = val.replace(/,/g, "");
      if (numStr !== "" && !isNaN(Number(numStr))) {
        return Number(numStr);
      }
    }
    return val;
  });

  return orderBy(list, iteratees, sortDirections);
};
